import { useEffect, useState } from 'react'
import {
    faJava,
    faLinux,
    faAws,
} from '@fortawesome/free-brands-svg-icons'
import {
    siCplusplus,
    siMongodb,
    siPostgresql,
} from 'simple-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    
    useEffect(() => {
        document.documentElement.style.setProperty('--text-opacity', '1');
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)

        
        return () => clearTimeout(timer)
    }, [])

    const SimpleIcon = ({ icon, color, size = 40 }) => (
        <svg
            viewBox="0 0 24 24"
            width={size}
            height={size}
            fill={color || `#${icon.hex}`}
            aria-label={icon.title}
        >
            <path d={icon.path} />
        </svg>
    )

    return (
        <>
            <div className="container about-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        I'm focused on building systems that remain predictable under pressure.
                        I enjoy the parts of engineering where ambiguity is high, documentation is thin, and most people get stuck, that’s usually where my work begins.
                    </p>
                    <p>
                        I care deeply about architecture, data flow, and performance, and I prefer solutions that are readable, scalable, and fast to ship.
                        One of my core projects explores a different interaction model altogether: a cross-platform terminal that accepts verbs instead of traditional commands. It reflects how I think about systems, tools should adapt to humans, not the other way around.
                    </p>
                    <p>
                        I’m currently aiming for an SDE-1 role, but titles matter less to me than impact. What matters is what I can build, how reliably it runs, and how well it can be reasoned about when things go wrong.
                    </p>
                </div>

                <div className="stage-cube-cont">
                    <div className="cubespinner">
                        <div className="face1">
                            <FontAwesomeIcon icon={faJava} color="#DD0031" />
                        </div>
                        <div className="face2">
                            <FontAwesomeIcon icon={faLinux} color="#F06529" />
                        </div>
                        <div className="face3">
                            <SimpleIcon icon={siCplusplus} color="#28A4D9" />
                        </div>
                        <div className="face4">
                            <SimpleIcon icon={siMongodb} color="#5ED4F4" />
                        </div>
                        <div className="face5">
                            <FontAwesomeIcon icon={faAws} color="#EFD81D" />
                        </div>
                        <div className="face6">
                            <SimpleIcon icon={siPostgresql} color="#EC4D28" />
                        </div>
                    </div>
                </div>
            </div>
            <Loader type="pacman" />
        </>
    )
}

export default About